module.exports = __webpack_public_path__ + "7e65fbce0bb928de648e6908826dfe3c.png";